module.exports = __webpack_public_path__ + "static/media/logoSiemens.460ec128.png";